import { useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

import type { Gebied } from '@models/Gebied'
import type { Projectbetrokkene } from '@models/Projectbetrokkene'

import type { AuthenticatedUser } from '../../auth/types/AuthenticatedUser'
import { isProjectbetrokkeneWijzigbaar } from '../util/projectbetrokkene-util'

import { CreateVerantwoordelijke } from './dialogs/CreateVerantwoordelijke'

export { CreateVerantwoordelijkeButton }

type Props = {
  user: AuthenticatedUser
  projectType: Projectbetrokkene['projectType']
  gebieden: Gebied[]
}

/**
 * Alleen beheer voert verantwoordelijken op; een verantwoordelijke voert
 * binnen het eigen gebied betrokkenen op vanaf de ProjectbetrokkenenCard.
 */
const CreateVerantwoordelijkeButton = ({
  user,
  projectType,
  gebieden,
}: Props) => {
  const { canViewBeheer, canCreateProjectbetrokkene } = user
  const [open, setOpen] = useState(false)

  if (!canViewBeheer || !canCreateProjectbetrokkene) {
    return null
  }

  if (!isProjectbetrokkeneWijzigbaar(projectType)) {
    return (
      <Alert severity="info" sx={{ marginBottom: 2 }}>
        Projectbetrokkenen voor {projectType} zijn tijdelijk niet wijzigbaar
      </Alert>
    )
  }

  return (
    <Box sx={{ display: 'flex', marginBottom: 2, justifyContent: 'end' }}>
      <Button
        variant="contained"
        endIcon={<AddIcon />}
        onClick={() => setOpen(true)}
      >
        Verantwoordelijke toevoegen
      </Button>

      {open && (
        <CreateVerantwoordelijke
          onClose={() => setOpen(false)}
          gebieden={gebieden}
          projectType={projectType}
        />
      )}
    </Box>
  )
}
